var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.billOfLadingInquiry"),
        width: _vm.$selectByLang("300px", "340px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("60px", "80px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_BLNo") + "：" } },
            [
              _c("el-input", {
                attrs: { no: "BLNo" },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Query", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }